/**
 * A country.
 */
export interface Country {
  readonly id: string; // id in this case is a literal unique country code (same as 'code')
  readonly code: string;
  readonly name: string;
  readonly flagUrl?: string;
}

export function isCountry(country: Partial<Country>): country is Country {
  return (
    country.id !== undefined &&
    country.code !== undefined &&
    country.name !== undefined
  );
}
